import React from "react";

function UserAvatarSvg({ color = "#000000", width = 24, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 64 64"
      fill={color}
    >
      <g>
        <path
          fill={color}
          d="M46 51v6.386C41.846 59.686 37.074 61 32 61s-9.846-1.314-14-3.614V51c0-5.514 4.486-10 10-10h8c5.514 0 10 4.486 10 10zm15-19c0 9.193-4.305 17.395-11 22.712V51c0-7.72-6.28-14-14-14h-8c-7.72 0-14 6.28-14 14v3.712C7.305 49.395 3 41.193 3 32 3 16.01 16.01 3 32 3s29 13.01 29 29zm-18-8c0-6.065-4.935-11-11-11s-11 4.935-11 11 4.935 11 11 11 11-4.935 11-11zm-11-7c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7z"
          opacity="1"
        ></path>
        <path
          fill="#ffffff"
          d="M32 3C16.01 3 3 16.01 3 32s13.01 29 29 29 29-13.01 29-29S47.99 3 32 3zm0 54C18.215 57 7 45.785 7 32S18.215 7 32 7s25 11.215 25 25-11.215 25-25 25z"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default UserAvatarSvg;
